export const SEARCH_RESULTS_LIMIT = 15

const MATERIAL_UNIT_LABELS: Record<string, string> = {
  m2: "Metro cuadrado",
  m3: "Metro cúbico",
  kg: "Kilogramo",
  ml: "Mililitro",
  cm: "Centímetro",
  u: "Unidad",
  l: "Litro",
  cm2: "Centímetro cuadrado",
  cm3: "Centímetro cúbico",
  gr: "Gramo",
  m: "Metro",
}

export function formatMaterialUnitLabel(unit: string | null | undefined): string {
  if (unit == null) return ""
  const trimmed = unit.trim()
  if (!trimmed) return ""
  const key = trimmed.toLowerCase().replace("m²", "m2").replace("m³", "m3")
  return MATERIAL_UNIT_LABELS[key] ?? trimmed
}

export function formatMaterialUnitMeasureLabel(unit: string | null | undefined): string {
  const label = formatMaterialUnitLabel(unit)
  if (!label) return ""
  return `Por ${label.charAt(0).toLowerCase()}${label.slice(1)}`
}

export function getMaterialsCatalogPricesUpdatedLabel(referenceDate: Date = new Date()): string {
  const month = referenceDate.toLocaleDateString("es-AR", { month: "long" })
  const year = referenceDate.getFullYear()
  return `Precios actualizados ${month} ${year}`
}

export function getMaterialsCatalogPricesUpdatedShortLabel(referenceDate: Date = new Date()): string {
  const month = referenceDate.toLocaleDateString("es-AR", { month: "short" }).replace(/\./g, "")
  return `Actualizado ${month} ${referenceDate.getFullYear()}`
}

export const FREQUENT_MATERIAL_NAMES = [
  "cemento",
  "arena",
  "ladrillo",
  "hierro",
  "cal",
  "yeso",
  "pintura",
  "ceramica",
  "pegamento",
  "bloque",
]

export const ulVariants = {
  hidden: {
    opacity: 0,
    height: 0,
  },
  visible: {
    opacity: 1,
    height: "auto",
    transition: {
      opacity: {
        duration: 0.8,
      },
      height: {
        duration: 0.3,
      },
    },
  },
}
